import { combineReducers } from "redux";
import {
    CARDS_PER_PAGE,
    REQUEST_REQ_EXP,
    RECEIVE_REQ_EXP,
    CREATE_REQ_EXP,
    RECEIVE_MEETING_PLACES,
    REQUEST_MEETING_PLACES,
    RECEIVE_MEETING_PLACES_EXPONENTS,
    REQUEST_MEETING_PLACES_EXPONENTS,
    SET_STATUS_FILTER
} from "./actions";
import {mergeObjectArrays} from "../../configureStore";

const initialState = {
    statusFilter: []
}

const items = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_REQ_EXP:
            if(action.page === 1)
                return action.meets;
            else
                return mergeObjectArrays(action.meets, state);
        case CREATE_REQ_EXP:
            return [action.meet, ...state];
        default:
            return state;
    }
}

const hasMoreReq = (state= false, action) => {
    switch(action.type) {
        case REQUEST_REQ_EXP:
            return true;
        case RECEIVE_REQ_EXP:
            return action.meets.length >= CARDS_PER_PAGE;
        default:
            return state;
    }
}
const isFetchingReq = (state = false, action) => {
    switch (action.type) {
        case REQUEST_REQ_EXP:
            return true;
        case RECEIVE_REQ_EXP:
            return false;
        default:
            return state;
    }
}

const isFetchingPlaces = (state = false, action) => {
    switch (action.type) {
        case REQUEST_MEETING_PLACES:
            return true;
        case RECEIVE_MEETING_PLACES:
            return false;
        case REQUEST_MEETING_PLACES_EXPONENTS:
            return true;
        case RECEIVE_MEETING_PLACES_EXPONENTS:
            return false;
        default:
            return state;
    }
}

const meetingPlaces = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_MEETING_PLACES:
            return action.data;
        default:
            return state;
    }
}

const meetingPlacesExponents = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_MEETING_PLACES_EXPONENTS:
            return action.data;
        default:
            return state;
    }
}

const filter = (state = { statusFilter: [] }, action) => {
    switch (action.type) {
        case 'SET_STATUS_FILTER':
            return {
                ...state,
                statusFilter: action.payload,
            };

        default:
            return state;
    }
};

const handleFilter = (state = false, action) => {
    switch (action.type) {
        case 'SET_OPEN_FILTER':
            return true
        case 'SET_CLOSE_FILTER':
            return false
        default:
            return state;
    }
};

export const getReqExp = (state) => state.items;
export const getFetchingReq = (state) => state.isFetchingReq;
export const getHasMoreReq = (state) => state.hasMoreReq;
export const getMeetingPlaces = (state) => state.meetingPlaces;
export const getFetchingPlaces = (state) => state.isFetchingPlaces;
export const getMeetingPlacesExponents = (state) => state.meetingPlacesExponents
export const getStatusFilter = (state) => state.filter
export const getStateFilter = (state) => state.handleFilter;


export default combineReducers({
    items,
    hasMoreReq,
    isFetchingReq,
    meetingPlaces,
    isFetchingPlaces,
    meetingPlacesExponents,
    filter,
    handleFilter
});
